// Auto-generated from docs/AchievementsGrid.csv. Edit the CSV and regenerate if needed.
export const PLAY_GAMES_ACHIEVEMENT_IDS: Record<string, string> = {
  "first_haul": "CgkIiN--zbcFEAIQAQ",
  "seasoned_prospector": "CgkIiN--zbcFEAIQAg",
  "veteran_of_the_mine": "CgkIiN--zbcFEAIQAw",
  "all_or_nothing": "CgkIiN--zbcFEAIQBA",
  "big_claim": "CgkIiN--zbcFEAIQBQ",
  "pot_raider": "CgkIiN--zbcFEAIQBg",
  "treasure_turnabout": "CgkIiN--zbcFEAIQBw",
  "narrow_escape": "CgkIiN--zbcFEAIQCA",
  "nest_egg": "CgkIiN--zbcFEAIQCQ",
  "growing_reserves": "CgkIiN--zbcFEAIQCg",
  "vault_keeper": "CgkIiN--zbcFEAIQCw",
  "found_lump": "CgkIiN--zbcFEAIQDA",
  "met_ferris": "CgkIiN--zbcFEAIQDQ",
  "facing_magnus": "CgkIiN--zbcFEAIQDg",
  "the_game_is_afoot": "CgkIiN--zbcFEAIQDw",
  "lump_crusher": "CgkIiN--zbcFEAIQEA",
  "ferris_felled": "CgkIiN--zbcFEAIQEQ",
  "magnus_mastered": "CgkIiN--zbcFEAIQEg",
  "case_closed": "CgkIiN--zbcFEAIQEw",
  "fool_s_gold": "CgkIiN--zbcFEAIQFA",
  "close_call": "CgkIiN--zbcFEAIQFQ",
};
